import { render, staticRenderFns } from "./BranchUpdate.vue?vue&type=template&id=12121bed&scoped=true"
import script from "./BranchUpdate.vue?vue&type=script&lang=js"
export * from "./BranchUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12121bed",
  null
  
)

export default component.exports